import type { SearchEntityType, SearchResponse } from '@peles/shared';
import { apiClient } from './client';

export async function searchEntities(
  type: SearchEntityType,
  query: string,
  limit = 20,
): Promise<SearchResponse> {
  const { data } = await apiClient.get<SearchResponse>('/search', {
    params: { type, q: query, limit },
  });
  return data;
}
